'use client';

import React, { useState } from 'react';
import { Button } from '@/components/ui/Button';
import Link from 'next/link';
import Image from 'next/image';
import NavigationBarSpacing from '@/components/layout/NavigationBarSpacing';
import { Play, Rocket, Timer } from 'lucide-react';

const HeroSection = () => {
  const [videoClicked, setVideoClicked] = useState(false);
  const videoRef = React.useRef<HTMLVideoElement>(null);

  const handlePlayClick = () => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    video.muted = false;
    video.controls = true;
    video.play();
    setVideoClicked(true);
  };

  return (
    <>
      <section className="relative px-8 md:px-8 pt-8 bg-cover bg-center bg-[url(/images/bg-wave.svg)]">
        <NavigationBarSpacing />
        <div className="relative text-center mb-4 md:mb-6 w-fit mx-auto md:space-x-2">
          <Link href="https://app.trovanorma.it/signup">
            <div className="inline-block text-neutral-800 hover:text-primary text-sm font-semibold rounded-full px-4 py-1 bg-white border-2 border-accent-300 shadow-md hover:shadow-lg transition duration-200">
              <Timer className="inline w-4 h-4 -mt-1 mr-1" />
              Accesso anticipato: Provalo gratis!
            </div>
          </Link>
          {/*<Link href="https://app.trovanorma.it/signup">
            <div className="inline-block text-neutral-800 hover:text-primary text-sm font-semibold rounded-full px-4 py-1 bg-white border-2 border-primary-200 shadow-md hover:shadow-lg transition duration-200 mt-2 md:mt-0">
              <Award className="inline w-4 h-4 -mt-1 mr-1" />
              Dai fondatori di Fatture in Cloud
            </div>
          </Link>*/}
        </div>
        <div className="flex flex-col items-center max-w-xl md:max-w-4xl mx-auto mb-4">
          <h1 className="font-funnel text-center text-4xl sm:text-5xl font-bold text-primary mt-6 md:mt-4 mb-4 leading-none">
            L&apos;<span className="text-accent">AI normativa e fiscale</span> che lavora come un
            esperto del tuo settore
          </h1>
          <p className="text-center mt-4 text-md sm:text-lg lg:text-xl text-neutral-600 text-muted-foreground lg:mx-0">
            Fisco, diritto, lavoro e compliance:{' '}
            <span className="font-funnel font-bold">Trovanorma</span> ti libera da ricerche infinite
            e dubbi interpretativi, con risposte solide, aggiornate e pronte all&apos;uso.
            <br />
            <strong>Perché nel tuo lavoro, ogni dettaglio conta.</strong>
          </p>
          <div className="flex flex-col md:flex-row justify-center md:justify-start mt-8 mb-12 gap-4">
            <Button asChild size="xl" variant="accent-default">
              <Link href={process.env.NEXT_PUBLIC_APP_URL + '/signup'}>
                <Rocket className="w-6 h-6 mr-3" />
                Provalo gratis ora
              </Link>
            </Button>
          </div>
          <div className="relative mb-8">
            <div
              className="relative aspect-3/2 md:aspect-auto overflow-hidden rounded-lg cursor-pointer"
              onClick={!videoClicked ? handlePlayClick : undefined}
            >
              {!videoClicked && (
                <>
                  <Image
                    src="/videos/hero_cover.webp"
                    alt="Anteprima video Trovanorma"
                    width={1280}
                    height={853}
                    priority
                    className="w-full h-auto"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="bg-accent/90 hover:bg-accent rounded-full p-5 shadow-lg transition duration-200">
                      <Play className="w-10 h-10 text-white fill-white" />
                    </div>
                  </div>
                </>
              )}
              <video
                ref={videoRef}
                playsInline
                className={videoClicked ? '' : 'hidden'}
              >
                <source src="/videos/hero.mp4" type="video/mp4" />
                Il tuo browser non supporta la riproduzione di questo video.
              </video>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
